import React, { useEffect } from 'react';

import { ReactComponent as UpvoteSvg } from '../../../../assets/upvote.svg';
import { FullAnswerFragment, ReactionType, useReactToAnswerMutation } from '../../../../graphql/gen/types';
import { ButtonColor, PlexButton } from '../../../shared/primitives/PlexButton';
import { logAnalytics } from '../../shared/logAnalytics';

interface Props {
  answer: FullAnswerFragment;
  disabled: boolean;
  onLoadingChanged: (loading: boolean) => void;
}

export const UpVoteAnswerButton = ({ answer, disabled, onLoadingChanged }: Props): React.ReactElement => {
  const [reactToAnswer, { loading: reactToAnswerLoading }] = useReactToAnswerMutation();
  useEffect(() => {
    onLoadingChanged(reactToAnswerLoading);
  }, [onLoadingChanged, reactToAnswerLoading]);

  const voteCount = answer.reactionCounts?.find((c) => c.type === ReactionType.Vote)?.count || 0;
  const isUpvoted = answer.currentUserReactions?.includes(ReactionType.Vote);

  const handleUpvoteClick = (): void => {
    reactToAnswer({
      variables: { reaction: { answerId: answer.id, type: ReactionType.Vote, checked: !isUpvoted } },
    }).then(() =>
      logAnalytics({ name: 'answer upvoted', details: { plexId: answer.question.plex.id, itemId: answer.id } })
    );
  };

  return (
    <PlexButton
      onClick={handleUpvoteClick}
      disabled={disabled}
      SvgIconLeft={UpvoteSvg}
      label={`Upvote (${voteCount})`}
      color={isUpvoted ? ButtonColor.TransparentBlue : ButtonColor.TransparentGray}
    />
  );
};
